import { Box, Grid, IconButton, Link, Typography } from "@mui/material";
import AppButton from "./AppButton";
import { useNavigate } from "react-router-dom";
import config from "../utils/config";
import { useTranslation } from "react-i18next";
import * as PropTypes from "prop-types";
// import Loader from "../assets/logo/loader.svg";
import Check from "../assets/logo/check.svg";
import { Close, HelpOutline } from "@mui/icons-material";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { checkKycSeenStatus } from "../store/actions";
import { checkSumSubStatus, logEvent } from "../store/api";
import { ACTIVITY_DETAIL, ACTIVITY_META, EVENTS } from "../utils/events";
import { useLocation } from 'react-router-dom';
import { isKycVerified } from "../utils";
export default function AppKycStatus({
  kycStatus = 0,
  mismatch = false,
}) {
  const location = useLocation();
  const navigate = useNavigate();
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const seen = useSelector(({ Auth }) => Auth?.kycSeen || false);
  const user = useSelector(({ Auth }) => Auth?.user || {});

  const [show, setShow] = useState(false);
  const [sumsubCheckLoading, setSumsubCheckLoading] = useState(true);
  const [onHoldinReview, setOnHoldinReview] = useState(false);
  const handleClick = (element) => {
    logEvent({
      current: EVENTS.HOME_PAGE.title,
      activity: `Clicked on ${element}`
    })
  }
  useEffect(() => {
    dispatch(checkKycSeenStatus(false));
    retrieveSumSubstatus();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  useEffect(() => {
    setShow(seen);
  }, [seen]);
  const retrieveSumSubstatus = async () => {
    if (kycStatus !== 3) { //Only check sumsub status for tryagain case
      setSumsubCheckLoading(false);
      return;
    }

    try {
      const response = await checkSumSubStatus();
      const _onHoldinReview = response.result.onHoldinReview

      if (_onHoldinReview) {
        setOnHoldinReview(_onHoldinReview);
      }
    } finally {
      setSumsubCheckLoading(false);
    }

  }
  const dismiss = async () => {
    dispatch(checkKycSeenStatus(true));
  };
  const handleVerificationStarted = () => {
    if (user?.userType?.toString() === '1') {
      logEvent({
        current: EVENTS.KYB.KYB_STARTED,
        activity: ACTIVITY_DETAIL.KYB.KYB_STARTED,
        meta: {
          data: {
            pathname: location.pathname,
            source: ACTIVITY_META.KYB.FROM_DASHBOARD
          }
        }
      })
    } else {
      logEvent({
        current: EVENTS.KYC.KYC_STARTED,
        activity: ACTIVITY_DETAIL.KYC.KYC_STARTED,
        meta: {
          data: {
            pathname: location.pathname,
            source: ACTIVITY_META.KYC.FROM_DASHBOARD
          }
        }
      })
    }

    navigate("/verification")
  }
  const handleTryAgain = () => {
    if (user?.userType?.toString() === '1') {
      logEvent({
        current: EVENTS.KYB.KYB_RETRY,
        activity: ACTIVITY_DETAIL.KYB.KYB_RETRY,
        meta: {
          data: {
            pathname: location.pathname,
            source: ACTIVITY_META.KYB.FROM_DASHBOARD
          }
        }
      })
    } else {
      logEvent({
        current: EVENTS.KYC.KYC_RETRY,
        activity: ACTIVITY_DETAIL.KYC.KYC_RETRY,
        meta: {
          data: {
            pathname: location.pathname,
            source: ACTIVITY_META.KYC.FROM_DASHBOARD
          }
        }
      })
    }

    navigate("/verification")
  }
  if (mismatch || kycStatus === 4 || kycStatus === 5 || (kycStatus === 3 && onHoldinReview) || kycStatus === 1) {
    if (kycStatus === 5 || kycStatus === 4) {
      //KYC_STATUS_BLOCKED
      if (user?.userType?.toString() === '1') {
        logEvent({
          current: EVENTS.KYB.KYB_COMPLETE,
          activity: ACTIVITY_DETAIL.KYB.KYB_COMPLETE,
          meta: {
            data: {
              pathname: location.pathname,
              source: ACTIVITY_META.KYB.KYB_BLOCKED
            }
          }
        })
      } else {
        logEvent({
          current: EVENTS.KYC.KYC_COMPLETE,
          activity: ACTIVITY_DETAIL.KYC.KYC_COMPLETE,
          meta: {
            data: {
              pathname: location.pathname,
              source: ACTIVITY_META.KYC.KYC_BLOCKED
            }
          }
        })
      }

    } else if (kycStatus === 4) {
      // KYC_STATUS_UNDER_MANUAL_REVIEW
      if (user?.userType?.toString() === '1') {
        logEvent({
          current: EVENTS.KYB.KYB_COMPLETE,
          activity: ACTIVITY_DETAIL.KYB.KYB_COMPLETE,
          meta: {
            data: {
              pathname: location.pathname,
              source: ACTIVITY_META.KYB.KYB_MANUAL_REVIEW
            }
          }
        })
      } else {
        logEvent({
          current: EVENTS.KYC.KYC_COMPLETE,
          activity: ACTIVITY_DETAIL.KYC.KYC_COMPLETE,
          meta: {
            data: {
              pathname: location.pathname,
              source: ACTIVITY_META.KYC.KYC_MANUAL_REVIEW
            }
          }
        })
      }
    }
    return (
      <Box
        padding={2}
        sx={{ backgroundColor: "rgba(0, 136, 245, 0.15)" }}
        borderRadius={3}
      >
        <Typography
          color={"#F8FAFF"}
          fontWeight={700}
          fontSize={16}
          textAlign="center"
        >
          {/* {t("accountReview")} */}
          {t("verificationProgress")}

        </Typography>
        <Typography
          variant="subtitle1"
          color={"#D4D4D8"}
          fontSize={14}
          fontWeight={400}
          textAlign="center"
        >
          {t("accountReviewText")}
        </Typography>

        <AppButton
          title={t("contact")}
          href={config.ZENDESK_SUPPORT}
          target="_blank"
          onClick={() => handleClick('contact support account review')}
        />
      </Box>
    );
  }
  if (isKycVerified(user) && show) {
    // complete
    if (user?.userType?.toString() === '1') {
      logEvent({
        current: EVENTS.KYB.KYB_COMPLETE,
        activity: ACTIVITY_DETAIL.KYB.KYB_COMPLETE,
        meta: {
          data: {
            pathname: location.pathname,
            source: ACTIVITY_DETAIL.KYB.KYB_COMPLETE
          }
        }
      })
    } else {
      logEvent({
        current: EVENTS.KYC.KYC_COMPLETE,
        activity: ACTIVITY_DETAIL.KYC.KYC_COMPLETE,
        meta: {
          data: {
            pathname: location.pathname,
            source: ACTIVITY_DETAIL.KYC.KYC_COMPLETE
          }
        }
      })
    }

    return (
      <Box
        sx={{
          backgroundColor: "rgba(0, 136, 245, 0.15)",
          paddingBottom: 3,
        }}
        borderRadius={3}
      >
        <Grid container>
          <Grid item xs={10} md={11}>
            <Box
              display={"flex"}
              flexDirection={"column"}
              alignItems={"center"}
              justifyContent={"center"}
              paddingTop={3}
              marginLeft={8}
            >
              <Check style={{ width: 42, height: 42 }} />
              <Typography fontSize={16} fontWeight={700} marginTop={2}>
                {t("verificationComplete")}
              </Typography>
            </Box>
          </Grid>
          <Grid
            item
            xs={2}
            md={1}
            display={"flex"}
            flexDirection={"column"}
            justifyContent={"flex-start"}
            alignItems={"flex-end"}
          >
            <IconButton
              aria-label="tracker"
              aria-describedby="kyc_status_dismiss"
              onClick={dismiss}
              sx={{
                padding: 1,
                position: "relative",
                background: "transparent",
              }}
            >
              <Close aria-label="tracker"
                aria-describedby="kyc_status_dismiss" />
            </IconButton>
          </Grid>
          {user?.referralId && <Grid item xs={10} md={11}>
            <Box
              display={"flex"}
              flexDirection={"column"}
              alignItems={"center"}
              justifyContent={"center"}
              marginLeft={8}
              marginTop={1}
            >
              <Typography textAlign={'center'}>{t('invite.verification.complete')}</Typography>
              <Link href={config.REWARDS_LINK} target="_blank" textAlign={'center'} fontSize={14}>{t('invite.verification.complete2')}</Link>
            </Box>
          </Grid>}
        </Grid>
      </Box>
    );
  }
  if (kycStatus === 0) {
    return (
      <Box
        padding={2}
        sx={{ backgroundColor: "rgba(0, 136, 245, 0.15)" }}
        borderRadius={3}
      >
        <Typography
          color={"#F8FAFF"}
          fontWeight={700}
          fontSize={16}
          textAlign="center"
        >
          {t("homepage.kycTitle")}
        </Typography>
        <Typography
          variant="subtitle1"
          color={"#D4D4D8"}
          fontSize={14}
          fontWeight={400}
          marginTop={1}
          textAlign="center"
        >
          {t("kyc.incomplete1")}
        </Typography>
        <Box display={"flex"} justifyContent={"center"} marginTop={2} marginBottom={2}>
          <Link
            href={config.KYC_WHY}
            target="_blank"
            rel="noreferrer"
            color={"#0088F5"}
            underline="always"
            display={"inline-flex"}
            alignItems={"center"}
            gap={0.75}
            fontSize={14}
            fontWeight={700}
            textTransform={"capitalize"}
            lineHeight={"20px"}
            sx={{
              textDecoration: "none",
              "&:visited": { color: "#0088F5" },
              "&:hover": { color: "#0088F5", textDecoration: "underline" },
            }}
          >
            <HelpOutline sx={{ fontSize: 25 }} />
            {t("kyc.why")}
          </Link>
        </Box>
        <AppButton
          buttontheme={"light"}
          title={t("kyc.completeins")}
          onClick={handleVerificationStarted}
        />
      </Box>
    );
  }
  // if (kycStatus === 1) {
  //   return (
  //     <Box
  //       display={"flex"}
  //       flexDirection={"column"}
  //       alignItems={"center"}
  //       justifyContent={"center"}
  //       sx={{
  //         backgroundColor: "rgba(0, 136, 245, 0.15)",
  //         paddingTop: 3,
  //         paddingBottom: 3,
  //       }}
  //       borderRadius={3}
  //     >
  //       <Loader className="loader" />
  //       <Typography fontSize={16} fontWeight={700} marginTop={2}>
  //         {t("verificationProgress")}...
  //       </Typography>
  //     </Box>
  //   );
  // }

  if (kycStatus === 3 && !sumsubCheckLoading) {
    return (
      <Box
        padding={2}
        sx={{ backgroundColor: "rgba(0, 136, 245, 0.15)" }}
        borderRadius={3}
      >
        <Typography
          color={"#F8FAFF"}
          fontWeight={700}
          fontSize={16}
          textAlign="center"
        >
          {t("kyc.failedTitle")}
        </Typography>
        <Typography
          variant="subtitle1"
          color={"#D4D4D8"}
          fontSize={14}
          fontWeight={400}
          textAlign="center"
        >
          {t("kyc.failed")}
        </Typography>

        <AppButton
          title={t("tryAgain")}
          onClick={handleTryAgain}
        />
      </Box>
    );
  }
}

AppKycStatus.propTypes = {
  kycStatus: PropTypes.number,
  mismatch: PropTypes.bool,
};
